export default __webpack_public_path__ + "static/media/2022連假攻略.2162c06e.jpeg";